import React from 'react';
import './ConfirmationMsg.css';

export const ConfirmationMsg = ({ text }) => <div className="confirmation">{text}</div>;
